import React, { useState, MouseEvent } from 'react'
import Menu from '@mui/material/Menu'
import FilterListIcon from '@mui/icons-material/FilterList'
import FilterPopover from '../Common/Filter/FilterPopover'
import { Badge, Button } from '@mui/material'
import { setFilters } from '../../redux/event/manageEvents/slice'
import { useAppDispatch } from '../../redux/store'

// Define the filter structure
interface FilterItem {
  id: string
  name: string
  filterSubItem: { id: string; label: string; value: string }[]
}

const EventFilter: React.FC = () => {
  const dispatch = useAppDispatch()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const defaultFilters = {
    status: [] as string[],
    category: [] as string[],
  }

  const [selectedFilters, setSelectedFilters] = useState<Record<string, string[]>>(defaultFilters)
  const [countOfSelectedFilter, setCountOfSelectedFilter] = useState(0)

  // Filter items for different pages
  const filterItems: FilterItem[] = [
    {
      id: 'status-all-check-box',
      name: 'status',
      filterSubItem: [
        { id: 'active-check-box', label: 'Active', value: 'active' },
        { id: 'inactive-check-box', label: 'Inactive', value: 'inactive' },
        { id: 'completed-check-box', label: 'Completed', value: 'completed' },
      ],
    },
    {
      id: 'category-all-check-box',
      name: 'category',
      filterSubItem: [
        { id: 'tids-check-box', label: 'TIDS', value: 'TIDS' },
        { id: 'happy-here-check-box', label: '#HAPPYHERE', value: 'happyhere' },
        { id: 'team-event-check-box', label: 'TEAM EVENT', value: 'teamEvent' },
        { id: 'cop-check-box', label: 'COP', value: 'COP' },
      ],
    },
  ]

  // Handle opening of the filter menu
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  // Handle closing of the filter menu
  const handleClose = () => {
    setAnchorEl(null)
  }

  // Handle filter change
  const handleFilterChange = (type: string, value: string, checked: boolean) => {
    const updatedFilters = checked
      ? [...selectedFilters[type], value]
      : selectedFilters[type].filter((item) => item !== value)

    const newFilters = {
      ...selectedFilters,
      [type]: updatedFilters,
    }

    setSelectedFilters(newFilters)
    dispatch(setFilters(newFilters))

    const countOfSelectedFilters = Object.values(newFilters).flat().length
    setCountOfSelectedFilter(countOfSelectedFilters)
  }

  // Handle select all change
  const handleSelectAllChange = (type: string, checked: boolean) => {
    const allValues =
      filterItems.find((item) => item.name === type)?.filterSubItem.map((item) => item.value) || []

    const newFilters = {
      ...selectedFilters,
      [type]: checked ? allValues : [],
    }

    setSelectedFilters(newFilters)
    dispatch(setFilters(newFilters))

    const countOfSelectedFilters = Object.values(newFilters).flat().length
    setCountOfSelectedFilter(countOfSelectedFilters)
  }

  // Handle reset of filters
  const handleResetFilters = () => {
    setSelectedFilters(defaultFilters)
    dispatch(setFilters(defaultFilters))

    setCountOfSelectedFilter(0)
  }

  return (
    <>
      <Badge badgeContent={countOfSelectedFilter} color='error'>
        <Button
          id='event-filter-button'
          color='success'
          startIcon={<FilterListIcon />}
          onClick={handleClick}
          size='small'
          aria-haspopup='true'
          aria-label='event-filter-button'
          aria-controls={open ? 'event-filter-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
        >
          Filter
        </Button>
      </Badge>
      <Menu
        id='event-filter-menu'
        MenuListProps={{
          'aria-labelledby': 'event-filter-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {[
          <FilterPopover
            key='filter-popover'
            filterItems={filterItems}
            selectedFilters={selectedFilters}
            onFilterChange={handleFilterChange}
            onSelectAllChange={handleSelectAllChange}
          />,
          <Button
            key='reset-button'
            id='filter-reset-button'
            onClick={handleResetFilters}
            fullWidth
            size='small'
          >
            CLEAR
          </Button>,
        ]}
      </Menu>
    </>
  )
}

export default EventFilter
